import { Button } from "@maker/design-system/ui/button";
import { Field, FieldInput, FieldLabel } from "@maker/design-system/ui/field";
import { RadioToggle, RadioToggleInput } from "@maker/design-system/ui/radio";
import { type SubmitEvent, useState } from "react";
import type { CreateTranscriptionInput } from "../../../../../hooks/use-transcriptions";

type TranscriptionsForm = {
	onSubmit: (input: CreateTranscriptionInput) => void;
};

const TranscriptionsForm = ({ onSubmit }: TranscriptionsForm) => {
	const [title, setTitle] = useState("");
	const [link, setLink] = useState("");

	const handleSubmit = (e: SubmitEvent<HTMLFormElement>) => {
		e.preventDefault();

		onSubmit({ title, url: link });
	};

	return (
		<section className="w-full max-w-120 p-6">
			<h2 className="font-semibold text-md">Criar uma transcrição</h2>

			<p className="mb-4 font-medium text-neutral-600 text-xs">
				Preencha os campos para criar uma transcrição usando IA.
			</p>

			<div className="rounded-lg bg-neutral-50 p-4">
				<form action="" onSubmit={handleSubmit}>
					<Field className="mb-4">
						<FieldLabel>Título</FieldLabel>

						<FieldInput
							name="title"
							placeholder="Meu Título"
							value={title}
							onChange={(e) => setTitle(e.target.value)}
							required
						/>
					</Field>

					<RadioToggle
						className="mb-4"
						name="format"
						value="video"
						label="Formato da fonte"
					>
						<RadioToggleInput value="video">Vídeo</RadioToggleInput>

						<RadioToggleInput value="audio" disabled>
							Áudio
						</RadioToggleInput>
					</RadioToggle>

					<RadioToggle
						className="mb-4"
						name="type"
						value="link"
						label="Tipo da fonte"
					>
						<RadioToggleInput value="link">Link</RadioToggleInput>

						<RadioToggleInput value="file" disabled>
							Arquivo
						</RadioToggleInput>
					</RadioToggle>

					<Field className="mb-4">
						<FieldLabel>Link do vídeo</FieldLabel>

						<FieldInput
							name="link"
							type="url"
							placeholder="https://..."
							value={link}
							onChange={(e) => setLink(e.target.value)}
							required
						/>
					</Field>

					<div className="text-right">
						<Button variant="black" size="sm" type="submit">
							Criar
						</Button>
					</div>
				</form>
			</div>
		</section>
	);
};

export { TranscriptionsForm };
